import { ExternalLink, Vault, Lock } from "lucide-react";

const ARSENAL_LINKS = [
  {
    id: "marion-auto",
    title: "Marion Auto Production Pilot",
    url: "https://local-stories-launch.emergent.host/marion-auto",
    category: "Production",
    accent: "#D4AF37",
  },
  {
    id: "demo-generator-prefill",
    title: "Live Demo Generator (Prefill)",
    url: "https://local-stories-launch.preview.emergentagent.com/demo-generator?name=Buckeye+Auto&city=Delaware&variant=work",
    category: "Preview",
    accent: "#60A5FA",
  },
  {
    id: "branded-foyer",
    title: "Branded Demo Foyer",
    url: "https://wingmanalfred.com/demo",
    category: "Live",
    accent: "#34D399",
  },
];

function hostnameOf(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export default function TitanArsenal() {
  return (
    <section className="glass-strong rounded-sm overflow-hidden" data-testid="titan-arsenal-section">
      <div className="px-6 py-4 border-b border-white/10 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <Vault size={16} className="text-gold" />
          <div>
            <div className="hud-label">Titan Arsenal · Vault</div>
            <div className="text-[10px] text-slate-500 mt-0.5">
              Command links for production drops &amp; demo dispatch
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-slate-500">
          <Lock size={11} className="text-gold" />
          <span>Leader Access Only</span>
        </div>
      </div>

      <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="titan-arsenal-grid">
        {ARSENAL_LINKS.map((link, idx) => (
          <ArsenalCard key={link.id} link={link} index={idx + 1} />
        ))}
      </div>

      <div className="px-6 py-4 border-t border-white/5 flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-slate-500 bg-[#0A1122]/50">
        <span className="w-1.5 h-1.5 rounded-full bg-gold light-pulse" />
        <span>{ARSENAL_LINKS.length} assets in vault</span>
      </div>
    </section>
  );
}

function ArsenalCard({ link, index }) {
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative block rounded-sm border border-white/10 bg-[#060B14] p-5 hover:border-gold/50 hover:bg-white/[0.03] transition-all overflow-hidden"
      data-testid={`arsenal-card-${link.id}`}
      style={{
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.02)",
      }}
    >
      {/* Left accent stripe */}
      <span
        className="absolute inset-y-0 left-0 w-0.5 opacity-70 group-hover:opacity-100 transition-opacity"
        style={{ backgroundColor: link.accent }}
      />

      <div className="flex items-start justify-between mb-4">
        <span
          className="inline-flex items-center px-2 py-0.5 rounded-sm text-[9px] font-display uppercase tracking-widest border"
          style={{
            color: link.accent,
            backgroundColor: `${link.accent}18`,
            borderColor: `${link.accent}55`,
          }}
        >
          {link.category}
        </span>
        <span className="text-[9px] font-mono-aviation text-slate-600">
          #{String(index).padStart(2, "0")}
        </span>
      </div>

      <div className="font-display text-lg text-white leading-tight mb-3 min-h-[3rem]">
        {link.title}
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-white/5">
        <div className="text-[10px] font-mono-aviation text-slate-500 truncate max-w-[70%]">
          {hostnameOf(link.url)}
        </div>
        <span
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-display text-slate-400 group-hover:text-gold transition-colors"
        >
          Open <ExternalLink size={11} />
        </span>
      </div>
    </a>
  );
}
